// LoginForm.tsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuth } from '../hooks/useAuth';

const LoginForm: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { loginWithRedirect, isLoading: auth0Loading } = useAuth0();
    const auth = useAuth();

    React.useEffect(() => {
        const initAuth = async () => {
            // If authenticated and we have user data, handle redirection
            if (!auth0Loading && !auth.isLoading && auth.isAuthenticated && auth.user) {
                const returnTo = location.state?.from?.pathname ||
                    (auth.user.role === 'system_admin' ? '/organizations' : '/dashboard');
                navigate(returnTo, { replace: true });
                return;
            }

            // If not authenticated and not loading, trigger login
            if (!auth0Loading && !auth.isLoading && !auth.isAuthenticated) {
                try {
                    await loginWithRedirect({
                        authorizationParams: {
                            redirect_uri: window.location.origin,
                            scope: 'openid profile email',
                            prompt: 'login'
                        },
                        appState: {
                            returnTo: '/dashboard'
                        }
                    });
                } catch (error) {
                    console.error('Login error:', error);
                }
            }
        };

        initAuth();
    }, [loginWithRedirect, auth0Loading, auth.isLoading, auth.isAuthenticated, auth.user, location.state?.from?.pathname, navigate]);

    if (auth.isLoading || auth0Loading) {
        return (
            <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
                <div>Loading...</div>
            </div>
        );
    }

    return null;
};

export default LoginForm;